import { service } from '@ember/service'
import Route from '@ember/routing/route'
import type ContentfulClientService from 'teacher-ui-client/services/contentful-client'

interface Params extends Record<string, unknown> {
  entry_id: string
}

export default class PrintablesSetRoute extends Route {
  @service
  contentfulClient!: ContentfulClientService

  async model(params: Params) {
    const entryId = params.entry_id
    const bookSet = await this.contentfulClient.getPreviewBookSet(entryId)
    return {
      bookSet,
    }
  }
}
